<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    style="z-index: 5000;"
    @keydown.esc="cancel"
  >
    <v-card class="p-0">
      <v-card-title class="p-0">
        <img :src="headerImage" />
      </v-card-title>
      <v-card-text class="pl-5 pt-4 pb-0">
        <h3 class="black--text">{{$t('PremiumFeaturesDialog.Title')}}</h3>
        <div class="text--gray">{{$t('PremiumFeaturesDialog.Description')}}</div>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-4" @click="cancel" plain>{{$t('GeneralTranslations.Close')}}</v-btn>
        <a href="mailto:support@getreshub.com" target="_blank">
          <v-btn color="primary" dark>{{$t('PremiumFeaturesDialog.Contact')}}</v-btn>
        </a>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PremiumFeaturesDialog",
  data() {
    return {
      headerImage: require("../../assets/premium-features-header.png"),
      dialog: false,
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
img {
  max-width: -webkit-fill-available;
}
</style>
